class DrawerStorePickup extends HTMLElement {
    constructor() {
        super();

        this.client = new window.ShopifyStorefrontClient(window.theme.storefront.endpoint, window.theme.storefront.access_token);
        this.lowStock = Number(this.getAttribute("data-low-stock"));
        this.productHandle = this.getAttribute("data-product-handle");
        this.setupListeners();
    }

    async connectedCallback() {
    }

    setupListeners() {
        document.querySelector(`#in-store-stock-checker`).addEventListener('click',
            this.viewStockChecker.bind(this)
        );

        document.querySelector(`#pickup-current-location`).addEventListener('click',
            this.getCurrentLocation.bind(this)
        );

        document.querySelector(`select[name="stock-size"]`).addEventListener('change',
            this.onLocationChange.bind(this)
        );

        document.querySelector(`input[name="store-pickup-input"]`).addEventListener('change',
            this.onLocationChange.bind(this)
        );
    }
    async viewStockChecker() {
        document.querySelector('#drawer-store-pickup').classList.add('initialized', 'is-open');
        document.body.classList.add('overflow-hidden');
        document.querySelector(`input[name="store-pickup-input"]`).value = '';
        const storeList = await this.getClosestStores(-27.47, 153.03, 100);
        this.updateStoresList(storeList, true);
    }

    async getCurrentLocation() {
    const loadingOverlay = document.querySelector(`#drawer-store-pickup .loading-overlay`);
    document.querySelector(`input[name="store-pickup-input"]`).value = '';

        if (loadingOverlay) {
            loadingOverlay.classList.remove('hidden');
            document.querySelector(`#store-pickup-stores-list`).classList.add('loading');
        }

        function error() {
            document.querySelector('#pickup-current-location-error').classList.remove('hide-error');
            if (loadingOverlay) loadingOverlay.classList.add('hidden');
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(this.onGetCurrentLocationSuccess.bind(this), error);
        } else {
            if (loadingOverlay) {
                loadingOverlay.classList.add('hidden');
                document.querySelector(`#store-pickup-stores-list`).classList.remove('loading');
            }

        }
    }
    async onGetCurrentLocationSuccess(position) {
        const storeList = await this.getClosestStores(position.coords.latitude, position.coords.longitude, 10);
        this.updateStoresList(storeList);
        const loadingOverlay = document.querySelector(`#drawer-store-pickup .loading-overlay`);
        if (loadingOverlay) {
            loadingOverlay.classList.add('hidden');
            document.querySelector(`#store-pickup-stores-list`).classList.remove('loading');
        }
        document.querySelector(`input[name="store-pickup-input"]`).placeholder = 'Using current location';
    }

    async onLocationChange() {
        const loadingOverlay = document.querySelector(`#drawer-store-pickup .loading-overlay`);
        if (loadingOverlay) {
            loadingOverlay.classList.remove('hidden');
            document.querySelector(`#store-pickup-stores-list`).classList.add('loading');
        }

        let locationInput = document.querySelector(`input[name="store-pickup-input"]`)?.value;
        let locationDetails = await this.getLocationDetails(locationInput);

        if (!locationDetails) {
            document.querySelector('#pickup-input-location-error').classList.remove('hide-error');
        } else {

            const storeList = await this.getClosestStores(locationDetails.lat, locationDetails.long, 10);
            this.updateStoresList(storeList, locationDetails.sort);

        }
        if (loadingOverlay) {
            loadingOverlay.classList.add('hidden');
            document.querySelector(`#store-pickup-stores-list`).classList.remove('loading');
        }
    }

    async getClosestStores(lat,long, stores) {
        const selectElement = document.querySelector('#store-pickup-size-select');
        let selectedSize = selectElement.options[selectElement.selectedIndex].value;

        const availability = await this.client.getProductVariantStoreAvailability(this.productHandle, lat, long, "Size", selectedSize, stores);
        let storeList = availability.product.variantBySelectedOptions.storeAvailability.nodes;
        return storeList;
    }

    async getLocationDetails(location) {
        if (location === "") { return {lat: -27.47, long: 153.03 , sort: true} } // if no location is entered in the input then default to DC location

        let results = await this.client.getPostcodeMetaobject(location.replace(' ', '_'), 'postcode_address_details');
        if (results.metaobject == null ) {
            return false;
        } else {
            return {
                lat: parseFloat(results.metaobject.fields[0].value),
                long: parseFloat(results.metaobject.fields[1].value),
                sort: false
            };
        }
    }

    updateStoresList(stores, sort = false) {
        const storeListElement = document.querySelector("#store-pickup-stores-list");
        storeListElement.innerHTML = '';
        if (sort) {
            stores.sort((a, b) => {
                return b['quantityAvailable'] - a['quantityAvailable'];
            });
        }
        stores.forEach((store) => {
            let storeDiv = this.createStoreDiv(store);
            storeListElement.append(storeDiv);
        });
        document.querySelector('#pickup-input-location-error').classList.add('hide-error');
        document.querySelector('#pickup-current-location-error').classList.add('hide-error');
        document.querySelector(`input[name="store-pickup-input"]`).placeholder = 'Suburb/Postcode';

    }

    createStoreDiv(store) {
        let storeDiv = document.createElement("div");
        storeDiv.classList.add("pickup-store");

        let stockLevel = '';

        if (store.quantityAvailable > this.lowStock ) {
            stockLevel = '<span> - Available</span>';
        } else if (!store.available){
            stockLevel = '<span> - Sold Out</span>';
        } else if (store.quantityAvailable <= this.lowStock) {
            stockLevel = '<span > - Low Stock</span>';
        } else {
            stockLevel = '<span> - Sold Out</span>';
        }

        storeDiv.innerHTML =
            `
            <div>
                <span class="store-name">${store.location.name}</span> ${stockLevel}
            </div>
            <div class="store-address">
                <span>${store.location.address.address1}</span>
                <br>
                <span>${store.location.address.province}, ${store.location.address.city} ${store.location.address.zip}</span>
                <br>
                <a href="tel:${store.location.address.phone}">${store.location.address.phone}</a>
            </div>
       `
        return storeDiv;
    }
}

customElements.define('drawer-store-pickup', DrawerStorePickup);